import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineFormLayout のスタイル
 */
export const hotlineFormLayoutStyle = tv({
    slots: {
        cardWrap: ['w-full max-w-[830px]', 'mx-auto', 'mb-80 mt-24 lg:mt-32'],
        pageTitleInner: ['mx-auto'],
    },
    variants: {},
});
